module.exports = __webpack_public_path__ + "img/rozetka_delivery.402df139.png";